exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.cherry-canvas[data-v-3385f6fe] {\n  position: fixed;\n  top: 0;\n  bottom: 50%;\n  left: 0;\n  right: 0;\n  opacity: 0.6;\n  /*background:rgba(0, 0, 0, 0.3);*/\n  z-index: 1;\n}\n", "", {"version":3,"sources":["/./src/act/march_promotion/components/cherry.vue"],"names":[],"mappings":";AAAA;EACE,gBAAgB;EAChB,OAAO;EACP,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,aAAa;EACb,kCAAkC;EAClC,WAAW;CACZ","file":"cherry.vue","sourcesContent":[".cherry-canvas {\n  position: fixed;\n  top: 0;\n  bottom: 50%;\n  left: 0;\n  right: 0;\n  opacity: 0.6;\n  /*background:rgba(0, 0, 0, 0.3);*/\n  z-index: 1;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-3385f6fe&scoped=true!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/act/march_promotion/components/cherry.vue
// module id = 290
// module chunks = 0